// extracted by mini-css-extract-plugin
module.exports = {"container":"footer-module--container--1oXSM","icons":"footer-module--icons--1UeX4"};